import React from 'react';
import { Container, Row, Col, Button, Tabs, Tab } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/ProfilePreviewPage.css';

const ProfilePreviewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const profile = location.state?.profile;

  // If no profile is found
  if (!profile) {
    return (
      <Container className="profile-preview-container mt-5">
        <h3>No profile data found!</h3>
      </Container>
    );
  }

  return (
    <Container className="profile-preview-container">
      <h2 className="text-center mb-4">Profile Preview</h2>

      <Tabs defaultActiveKey="personal" className="mb-3">
        {/* ---------------- Personal ---------------- */}
        <Tab eventKey="personal" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={6} lg={3}><strong>Name:</strong> {profile.name || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Gender:</strong> {profile.gender || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Height:</strong> {profile.personalDetails.height || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Weight:</strong> {profile.personalDetails.weight || 'Not provided'}</Col>
            </Row>
            <Row className="mt-3">
              <Col md={6} lg={3}><strong>Blood Group:</strong> {profile.personalDetails.bloodGroup || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Body Type:</strong> {profile.personalDetails.bodyType || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Complexion:</strong> {profile.personalDetails.complexion || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Marital Status:</strong> {profile.personalDetails.maritalStatus || 'Not provided'}</Col>
            </Row>
          </div>
        </Tab>

        {/* ---------------- Birth ---------------- */}
        <Tab eventKey="birth" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={6} lg={3}><strong>DOB:</strong> {profile.birthDetails.dob || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Birth Place:</strong> {profile.birthDetails.birthPlace || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Birth Time:</strong> {profile.birthDetails.birthTime || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Birth Day:</strong> {profile.birthDetails.birthDay || 'Not provided'}</Col>
            </Row>
            <Row className="mt-3">
              <Col md={6} lg={3}><strong>Star:</strong> {profile.birthDetails.star || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Moon Sign:</strong> {profile.birthDetails.moonsign || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Gothra:</strong> {profile.birthDetails.gothra || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Pada:</strong> {profile.birthDetails.pada || 'Not provided'}</Col>
            </Row>
          </div>
        </Tab>

        {/* ---------------- Family ---------------- */}
        <Tab eventKey="family" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={6} lg={3}><strong>Father:</strong> {profile.familyDetails.fatherName || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Mother:</strong> {profile.familyDetails.motherName || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Brothers:</strong> {profile.familyDetails.noOfBrothers || '0'}</Col>
              <Col md={6} lg={3}><strong>Sisters:</strong> {profile.familyDetails.noOfSisters || '0'}</Col>
            </Row>
          </div>
        </Tab>

        {/* ---------------- Education ---------------- */}
        <Tab eventKey="education" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={6} lg={3}><strong>Stream:</strong> {profile.educationsDetails.educationStream || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Qualification:</strong> {profile.educationsDetails.qualification || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Occupation:</strong> {profile.educationsDetails.occupation || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Annual Income:</strong> {profile.educationsDetails.annualIncome || 'Not provided'}</Col>
            </Row>
          </div>
        </Tab>

        {/* ---------------- Contact ---------------- */}
        <Tab eventKey="contact" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={6}><strong>Email:</strong> {profile.contactDetails.email || 'Not provided'}</Col>
              <Col md={6}><strong>Mobile:</strong> {profile.contactDetails.mobileNo1 || 'Not provided'}</Col>
            </Row>
            <Row className="mt-3">
              <Col md={6}><strong>Address:</strong> {profile.contactDetails.address1 || 'Not provided'}</Col>
              <Col md={6}><strong>District:</strong> {profile.contactDetails.district || 'Not provided'}</Col>
            </Row>
          </div>
        </Tab>

        {/* ---------------- Looking For ---------------- */}
        <Tab eventKey="lookingfor" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={6} lg={3}><strong>Age:</strong> {profile.lookingForDetails.ageFrom || '18'} - {profile.lookingForDetails.ageTo || '25'}</Col>
              <Col md={6} lg={3}><strong>Height:</strong> {profile.lookingForDetails.height || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Caste:</strong> {profile.lookingForDetails.caste || 'Not provided'}</Col>
              <Col md={6} lg={3}><strong>Qualification:</strong> {profile.lookingForDetails.qualification || 'Not provided'}</Col>
            </Row>
          </div>
        </Tab>

        {/* ---------------- Payments ---------------- */}
        <Tab eventKey="payments" >
          <div className="tab-content-wrapper">
            <Row>
              <Col md={4}><strong>Payment Date:</strong> {profile.paymentsDetails.paymentDate || 'Not provided'}</Col>
              <Col md={4}><strong>Amount:</strong> {profile.paymentsDetails.amount ? `₹${profile.paymentsDetails.amount}` : 'Not provided'}</Col>
              <Col md={4}><strong>Transaction ID:</strong> {profile.paymentsDetails.transactionId || 'Not provided'}</Col>
            </Row>
          </div>
        </Tab>
      </Tabs>

      <div className="text-center mt-4">
        <Button variant="secondary" onClick={() => navigate(-1)}>Back to Edit</Button>
      </div>
    </Container>
  );
};

export default ProfilePreviewPage;